import React, { useEffect, useState } from 'react'
import { Drawer, Pagination, Skeleton, Tabs } from 'antd'
import axiosRequest from '../../../../helpers/axios-request.helper'
import convertJsonToUrlParams from '../../../../helpers/convert-json-to-url-params'
import axiosErrorHelper from '../../../../helpers/axios-error.helper'
import styles from '../../../../pages/acquisition/dashboard-page.module.scss'
import { Link } from 'react-router-dom'
import moment from 'moment/moment'

const UploadsDrawer = ({ visible, setVisibility }) => {
  const tabs = [
    { tab: 'All', key: '2' },
    { tab: 'Internal', key: '0' },
    { tab: 'Invited', key: '1' },
  ]
  const [loading, setLoading] = useState(true)
  const [data, setData] = useState({ data: [], total: 0 })
  const [filters, setFilters] = useState({
    limit: 40,
    page: 1,
    invited: '0',
  })

  const getData = () => {
    setLoading(true)
    axiosRequest(
      `api/v1/acquisition/data/admin/get-uploads${convertJsonToUrlParams(
        filters,
      )}`,
      'get',
      null,
      true,
    )
      .then((res) => {
        if (res.data && res.data.success) {
          setData({
            data: res.data.uploads.data,
            total: res.data.uploads.total,
          })
        }
      })
      .catch((e) => {
        axiosErrorHelper(e)
      })
      .finally(() => {
        setLoading(false)
      })
  }

  useEffect(() => {
    getData()
    // eslint-disable-next-line
  }, [visible, filters])

  return (
    <Drawer
      title={`Uploads (${data.total})`}
      visible={visible}
      destroyOnClose
      onClose={() => {
        setVisibility(false)
      }}
      width={720}
    >
      <Tabs
        defaultActiveKey="uploads_0"
        onChange={(activeKey) =>
          setFilters({ ...filters, invited: activeKey.replace('uploads_', '') })
        }
      >
        {tabs.map((tab) => (
          <Tabs.TabPane tab={tab.tab} key={`uploads_${tab.key}`}>
            {loading ? (
              <Skeleton active />
            ) : (
              <div>
                {data.data && (
                  <div className={styles.CardList}>
                    {data.data.map((upload) => (
                      <div
                        className={styles.ListItem}
                        key={`csv-uploads__${upload.id}`}
                      >
                        <div className={styles.Info}>
                          <p className="mb-1">
                            <Link
                              to={`/acquisition/data-parser?uploaderFile=${upload.id}`}
                            >
                              {upload.name.substring(0, 18) + '...'}
                            </Link>
                          </p>
                          {upload.get_user && (
                            <p className="mb-1">
                              <small>
                                <strong>{upload.get_user.name}</strong>
                              </small>
                            </p>
                          )}
                          <p className="mb-0">
                            <small>
                              <strong>
                                {moment(upload.created_at).format(
                                  'MM/DD/YYYY HH:mm',
                                )}{' '}
                                (UTC)
                              </strong>
                            </small>
                          </p>
                        </div>
                        <div className={`${styles.Info} text-start`}>
                          {upload.totalListings
                            ? `${upload.totalListings}`
                            : '0'}{' '}
                          Properties found
                        </div>
                        <div className={`${styles.Info} text-start`}>
                          {upload.uploadedListings
                            ? `${upload.uploadedListings}`
                            : '0'}{' '}
                          Properties processed
                        </div>
                        <div className={`${styles.Info} text-start`}>
                          {upload.smsSent ? `${upload.smsSent}` : '0'} SMS sent
                        </div>
                        <div className={`${styles.Info} text-start`}>
                          {upload.emailSent ? `${upload.emailSent}` : '0'}{' '}
                          emails sent
                        </div>
                      </div>
                    ))}
                  </div>
                )}
                {filters.limit < data.total && (
                  <Pagination
                    className="mt-4"
                    size="small"
                    current={filters.page}
                    pageSize={filters.limit}
                    total={data.total}
                    showSizeChanger={false}
                    onChange={(page) => setFilters({ ...filters, page })}
                  />
                )}
              </div>
            )}
          </Tabs.TabPane>
        ))}
      </Tabs>
    </Drawer>
  )
}

export default UploadsDrawer
